module.exports = __webpack_public_path__ + "5b4d8fa54ddd25f6faefe9a5f25cd491.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/tjx_companies_2023_chart.png
// module id = 1751
// module chunks = 0